"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SendPhoneCode_1 = __importDefault(require("./SendPhoneCode"));
var CodeVerify_1 = __importDefault(require("./CodeVerify"));
var Step1 = function (_a) {
    var setNextStep = _a.setNextStep, setResetPassToken = _a.setResetPassToken;
    var _b = (0, react_1.useState)(true), canEditPhone = _b[0], setCanEditPhone = _b[1];
    var _c = (0, react_1.useState)(undefined), phone = _c[0], setPhone = _c[1];
    var _d = (0, react_1.useState)(undefined), tmpResetToken = _d[0], setTmpResetToken = _d[1];
    return (react_1.default.createElement(react_1.default.Fragment, null, canEditPhone ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SendPhoneCode_1.default, { closeEdited: function () {
                setCanEditPhone(false);
            }, phone: phone, setPhone: setPhone, setTmpResetToken: setTmpResetToken }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CodeVerify_1.default, { phone: phone, setNextStep: setNextStep, setCanEditPhone: setCanEditPhone, setResetPassToken: setResetPassToken, tempToken: tmpResetToken, setTmpResetToken: setTmpResetToken })))));
};
exports.default = Step1;
